import React, { useState, useEffect } from "react";
import { withStyles } from "@material-ui/core/styles";
import { Grid, Button, Typography } from "@material-ui/core";
import styles from "./styles";
import "animate.css/animate.css";
import BreakingNews from "../BreakingNews";
import calender from "../../images/calendar.gif";
import checkmark from "../../images/checkmark.svg";
import wrong from "../../images/wrong.svg";
import Influences from "../../images/Influences.svg";
import CountUp from "react-countup";
import "animate.css/animate.css";
import ThreeOptionVerticalSwitch from "../slider/ThreeOptionVerticalSwitch";
import AnswerModal from "../AnswerModal";

import { MdArrowForwardIos } from "react-icons/md";
const QuestionScreen = (props) => {
  const {
    classes,
    questionAnswer,
    setShowThirdScreen,
    addToTotalBalance,
    totalBalance,
    previousBalance,
    nextQuestion,
    setAnsweredCorrectly,
    answeredCorrectly,
    open,
  } = props;
  const [submitted, setSubmitted] = useState(false);
  const [selected, setSelected] = useState(-1); //0 for for index, 1 for for second index
  const [selectedOptions, setSelectedOptions] = useState([0, 0, 0, 0]); //0 for for index, 1 for for second index
  const [starthere, setStarthere] = useState(true);
  function setBackground(e) {
    e.target.style.background = "#003E4C";
    e.target.style.color = "#fff";
  }

  useEffect(() => {
    if (submitted) {
      console.log("seleced Options", selectedOptions);
      // setTimeout(() => {
      //   setShowAnswer(true);
      setAnsweredCorrectly(
        JSON.stringify(selectedOptions) ===
          JSON.stringify(questionAnswer.correctAnswers)
      );
      //   addToTotalBalance(selected);
      // }, 2000);
    }
  }, [submitted]);

  return (
    <Grid container alignItems="center" direction="column">
      <Grid
        container
        item
        justify="center"
        alignItems="center"
        className={classes.outerGrid}
      >
        <BreakingNews questionAnswer={questionAnswer} />
        <>
          <Grid
            container
            item
            justify="center"
            alignItems="center"
            className={classes.mainContainer}
            spacing={2}
          >
            <Grid xs={2} className={classes.swicthContainer}>
              <ThreeOptionVerticalSwitch
                selected={selectedOptions}
                setSelectedOptions={setSelectedOptions}
                index={0}
                setStarthere={setStarthere}
                starthere={starthere}
              >
                <Typography className={classes.label}>
                  {"Interest Rate on\nReserve Balances"}
                </Typography>
              </ThreeOptionVerticalSwitch>
            </Grid>
            <Grid xs={1} className={classes.swicthIcon}>
              <div className={classes.imageContainer}>
                <img
                  src={Influences}
                  alt="causes"
                  className={classes.swicthArrow}
                />
              </div>
            </Grid>
            <Grid xs={2} className={classes.swicthContainer}>
              <ThreeOptionVerticalSwitch
                selected={selectedOptions}
                setSelectedOptions={setSelectedOptions}
                index={1}
                setStarthere={setStarthere}
              >
                <Typography className={classes.label}>
                  {"Short-Term Market\nInterest Rate"}
                </Typography>
              </ThreeOptionVerticalSwitch>
            </Grid>
            <Grid xs={1} className={classes.swicthIcon}>
              <div className={classes.imageContainer}>
                <img
                  src={Influences}
                  alt="causes"
                  className={classes.swicthArrow}
                />
              </div>
            </Grid>
            <Grid xs={2} className={classes.swicthContainer}>
              <ThreeOptionVerticalSwitch
                selected={selectedOptions}
                setSelectedOptions={setSelectedOptions}
                index={2}
                setStarthere={setStarthere}
              >
                <Typography className={classes.label}>
                  Consumer Spending and Business Investment
                </Typography>
              </ThreeOptionVerticalSwitch>
            </Grid>
            <Grid xs={1} className={classes.swicthIcon}>
              <div className={classes.imageContainer}>
                <img
                  src={Influences}
                  alt="causes"
                  className={classes.swicthArrow}
                />
              </div>
            </Grid>
            <Grid xs={2} className={classes.swicthContainer}>
              <ThreeOptionVerticalSwitch
                selected={selectedOptions}
                setSelectedOptions={setSelectedOptions}
                index={3}
                setStarthere={setStarthere}
              >
                <Typography className={classes.label}>{questionAnswer.type}</Typography>
              </ThreeOptionVerticalSwitch>
            </Grid>
          <Button
            className={`${classes.nextButton} ${
              !submitted && classes.submitButton
            }`}
            // disabled={selected === -1}
            onClick={() =>
              submitted ? console.log("helllo") : setSubmitted(true)
            }
          >
            SUBMIT
          </Button>
          </Grid>
        </>
        {/* )} */}
        <AnswerModal
          nextQuestion={nextQuestion}
          question={questionAnswer}
          answeredCorrectly={answeredCorrectly}
          submitted={submitted}
          setSubmitted={setSubmitted}
          setShowThirdScreen={setShowThirdScreen}
        />
      </Grid>
    </Grid>
  );
};

export default withStyles(styles)(QuestionScreen);
